import { render } from "./DccList.vue?vue&type=template&id=3d95b1bc&scoped=true"
import script from "./DccList.vue?vue&type=script&lang=js"
export * from "./DccList.vue?vue&type=script&lang=js"

import "./DccList.vue?vue&type=style&index=0&id=3d95b1bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d95b1bc"],['__file',"src/views/Dccs/DccList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d95b1bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d95b1bc', __exports__)) {
    api.reload('3d95b1bc', __exports__)
  }
  
  module.hot.accept("./DccList.vue?vue&type=template&id=3d95b1bc&scoped=true", () => {
    api.rerender('3d95b1bc', render)
  })

}


export default __exports__